// eslint-disable-next-line import-x/no-named-as-default
import DOMPurify from 'dompurify';

/**
 * Утилита которая санитизирует HTML строку с помощью DOMPurify
 */
export function sanitizeHtml(html: string): string {
  if (!html) {
    return '';
  }

  const sanitizedDom = DOMPurify.sanitize(html, {
    ADD_ATTR: ['target', 'rel'],
    RETURN_DOM: true,
  });

  if (!(sanitizedDom instanceof HTMLElement)) {
    return '';
  }

  const anchorElements = sanitizedDom.querySelectorAll<HTMLAnchorElement>('a[href]');

  anchorElements.forEach((anchor) => {
    anchor.setAttribute('target', '_blank');
    anchor.setAttribute('rel', 'noopener noreferrer');
  });

  return sanitizedDom.innerHTML;
}
